import ScreenSizeDetector from 'screen-size-detector';

const { height, width } = new ScreenSizeDetector();
export { height, width };
